/**
 * Main Initialization
 */
document.addEventListener('DOMContentLoaded', () => {
  initializeTaxAddon(1);
  document.addEventListener('line-item:change:end', (e) => {
    const { type } = e.detail;
    console.log('Type received:', type);
    initializeTaxAddon(2, type);
  });
});

/**
 * Orchestrator: Checks tax add-on logic and updates cart if needed.
 */
async function initializeTaxAddon(num, sourceType) {
  const normalizedType = normalizeTaxAddonType(sourceType);
  console.log(`[TaxAddon] initializeTaxAddon called (pass ${num})`, { sourceType, normalizedType });

  const cart = await getCartAttributes();
  console.log('[TaxAddon] Cart fetched:', { itemCount: cart.items?.length, currency: cart.currency?.iso_code });

  // 1. Get tax add-on changes
  const updates = getTaxAddonUpdates(cart, normalizedType);

  // 2. Update if changes are needed
  if (updates) {
    console.log('[TaxAddon] Changes detected, syncing cart...', { updates });
    await updateCartData(null, updates);
    return;
  }

  console.log('[TaxAddon] No changes needed.');
}

/**
 * LOGIC FUNCTION: Tax Add-on Product
 * @returns {Object|null} Updates object or null if no change needed
 */
function getTaxAddonUpdates(cart, type = 'cart') {
  // 1. Try to get the fresh quantity from the updated HTML first
  const dataEl = document.querySelector(`#TaxInternalData-${type}`) || document.querySelector('#TaxInternalData-cart');
  console.log('[TaxAddon] TaxInternalData element found:', { type, found: !!dataEl });

  if (!dataEl) {
    console.log('[TaxAddon] No TaxInternalData element found, skipping.');
    return null;
  }

  const taxVariantId = dataEl.dataset.taxId;
  const targetQty = parseInt(dataEl.dataset.taxQty, 10) || 0;
  console.log('[TaxAddon] Tax variant config:', { type, taxVariantId, targetQty, source: 'DOM' });

  if (!taxVariantId) {
    console.log('[TaxAddon] No taxVariantId found, skipping.');
    return null;
  }

  const cartItems = cart.items || [];
  const taxItem = cartItems.find((item) => item.id == taxVariantId);
  const currentQtyInCart = taxItem ? taxItem.quantity : 0;

  // Total items excluding the tax add-on itself
  const otherItemsCount = cartItems.length - (taxItem ? 1 : 0);
  console.log('[TaxAddon] Cart state:', { otherItemsCount, currentQtyInCart, taxItemInCart: !!taxItem });

  // 1. If cart is empty (no other items), the tax add-on must be removed (qty 0)
  if (otherItemsCount === 0 && currentQtyInCart > 0) {
    console.log('[TaxAddon] Removing tax add-on: cart has no other items.');
    return { [taxVariantId]: 0 };
  }

  // 2. If cart has other items, ensure tax add-on matches the targetQty
  if (otherItemsCount >= 1 && currentQtyInCart !== targetQty) {
    console.log(`[TaxAddon] Qty mismatch: current ${currentQtyInCart} -> target ${targetQty}`);
    return { [taxVariantId]: targetQty };
  }

  return null;
}

function normalizeTaxAddonType(sourceType) {
  if (sourceType === 'CART-DRAWER-ITEMS' || sourceType === 'drawer') {
    return 'drawer';
  }

  return 'cart';
}

/**
 * Perform AJAX update
 */
async function updateCartData(attributes, updates) {
  try {
    const payload = {};
    if (attributes) payload.attributes = attributes;
    if (updates) payload.updates = updates;

    console.log('[TaxAddon] Sending cart update:', JSON.stringify(payload));

    const response = await fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    console.log('[TaxAddon] Cart update response:', { status: response.status, message: data.message || 'OK' });

    // Check for errors
    if (data.message && data.message.includes('Cart Validation Error:')) {
      console.error('[TaxAddon] Cart validation error:', data.message);
      renderError(data.message);
      return;
    }

    // Refresh theme UI
    console.log('[TaxAddon] Dispatching cart:refresh...');

    window.location.reload();
  } catch (err) {
    console.error('[TaxAddon] Update failed:', err);
  }
}

/**
 * UI: Render Error Message
 */
function renderError(message) {
  const container = document.querySelector('.message-box-container');
  if (!container) return;
  const errorBox = document.createElement('div');
  errorBox.className = 'alert';
  errorBox.innerHTML = `<div class="alert-message"><div>${message}</div></div>`;
  const title = container.querySelector('div');
  title ? title.insertAdjacentElement('afterend', errorBox) : container.appendChild(errorBox);
}

/**
 * API: Get Cart
 */
async function getCartAttributes() {
  try {
    console.log('[TaxAddon] Fetching /cart.js...');
    const response = await fetch('/cart.js');
    const data = await response.json();
    console.log('[TaxAddon] Cart fetched successfully.');
    return data;
  } catch (error) {
    console.error('[TaxAddon] Failed to fetch cart:', error);
    return { attributes: {}, items: [] };
  }
}
